
export interface ConfirmEmailDto {
  userId?: string;
  token?: string;
}

export interface MySommelierDto {
  id: number;
  name: string;
  surname: string;
  slug: string;
  region?: string;
  city?: string;
  bio?: string;
  fileAttachmentId?: number | null;
}

export interface ChangeMySommelierResultDto {
  sommelierId: number;
  sommelierName: string;
  sommelierSlug: string;
}

export interface CreateClientUserDto {
  name: string;
  surname: string;
  email: string;
  phoneNumber?: string;
  password: string;
  slug?: string;
  pickUpId?: number | null;
  documentNumber?: string;
  address?: string;
}
